<template>
  <el-container>
    <main class="page__container">
      <div class="container">
        <h2>Hardware группы</h2>
        <search :query.sync="query" @search="search" />
        <el-table ref="table" :data="items">
          <el-table-column label="Название группы">
            <template slot-scope="scope">
              <router-link
                class="link"
                :to="{ name: 'hw-groups:edit', params: { id: scope.row.id_hardware_group } }"
              >
                {{ scope.row.name }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column label="MCore-сервера">
            <template slot-scope="scope">
              {{ serverNames(scope.row.proxy_servers) }}
            </template>
          </el-table-column>
          <el-table-column label="ArchCore-сервера">
            <template slot-scope="scope">
              {{ serverNames(scope.row.servers) }}
            </template>
          </el-table-column>
          <el-table-column label="Archive Caster сервера">
            <template slot-scope="scope">
              {{ serverNames(scope.row.archive_casters) }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="list__pagination"
          layout="prev, pager, next"
          :page-size="count"
          :total="total"
          :current-page="page"
          @current-change="changePage"
        />
      </div>
    </main>
    <el-footer class="page__active_bar">
      <el-button
        v-if="$can('create', 'hardware_groups')"
        class="page__active_button"
        icon="el-icon-plus"
        type="primary"
        @click="$router.push({ name: 'hw-groups:create' })"
      >
        Добавить
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import routeList from "@/core/mixins/routeList";
import Search from "@/components/Search";

export default {
  name: "HwGroupsList",
  components: {
    Search,
  },
  mixins: [routeList],
  data() {
    return {
      query: "",
    };
  },
  computed: {
    ...mapState("hwGroups", {
      items: (state) => state.hwGroups.data,
      total: (state) => state.hwGroups.total,
      count: (state) => state.hwGroups.count,
    }),
    ...mapGetters("hwGroups", ["getQuery"]),
  },
  methods: {
    ...mapActions("hwGroups", {
      getList: "GET_HW_GROUPS",
    }),
    serverNames(servers) {
      return (servers || []).map((server) => server.name).join(", ");
    },
    ...mapMutations("hwGroups", {
      setQuery: "SET_QUERY",
    }),
  },
};
</script>

<style></style>
